/* Store Credit ifadelerini Cash Back olarak değiştiren script */

(function () {
  // Önce spesifik ifade
  const APPLY_FROM_REGEX = /apply\s*store\s*credits?/gi;
  const APPLY_TO_TEXT = "Apply Celesty Cash";

  // Genel ifade
  const CREDIT_FROM_REGEX = /store\s*credits?/gi;
  const CREDIT_TO_TEXT = "Cash Back";

  const SKIP_TAGS = new Set(["SCRIPT", "STYLE", "NOSCRIPT", "IFRAME"]);

  function replaceInAttributes(el) {
    const attrs = ["placeholder", "title", "aria-label", "value"];
    for (const a of attrs) {
      if (!el.hasAttribute || !el.hasAttribute(a)) continue;
      let v = el.getAttribute(a);
      if (typeof v !== "string") continue;

      // Önce Apply Store Credit
      if (APPLY_FROM_REGEX.test(v)) {
        v = v.replace(APPLY_FROM_REGEX, APPLY_TO_TEXT);
      }

      // Sonra Store Credit(s)
      if (CREDIT_FROM_REGEX.test(v)) {
        v = v.replace(CREDIT_FROM_REGEX, CREDIT_TO_TEXT);
      }

      el.setAttribute(a, v);

      APPLY_FROM_REGEX.lastIndex = 0;
      CREDIT_FROM_REGEX.lastIndex = 0;
    }
  }

  function replaceTextNodes(root) {
    if (!root || root.nodeType !== 1) return;
    if (SKIP_TAGS.has(root.tagName)) return;

    replaceInAttributes(root);

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: (node) => {
          const parent = node.parentElement;
          if (!parent || SKIP_TAGS.has(parent.tagName)) return NodeFilter.FILTER_REJECT;
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    let n;
    while ((n = walker.nextNode())) {
      let txt = n.nodeValue;

      // Önce Apply Store Credit
      if (APPLY_FROM_REGEX.test(txt)) {
        txt = txt.replace(APPLY_FROM_REGEX, APPLY_TO_TEXT);
      }

      // Sonra Store Credit(s)
      if (CREDIT_FROM_REGEX.test(txt)) {
        txt = txt.replace(CREDIT_FROM_REGEX, CREDIT_TO_TEXT);
      }

      n.nodeValue = txt;

      APPLY_FROM_REGEX.lastIndex = 0;
      CREDIT_FROM_REGEX.lastIndex = 0;
    }
  }

  function runInitial() {
    replaceTextNodes(document.body);
  }

  let rafId = null;
  const observer = new MutationObserver((mutations) => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      for (const m of mutations) {
        if (m.type === "characterData" && m.target && m.target.parentElement) {
          replaceTextNodes(m.target.parentElement);
        } else if (m.type === "childList") {
          m.addedNodes && m.addedNodes.forEach((node) => {
            if (node.nodeType === 1) replaceTextNodes(node);
          });
        }
      }
    });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInitial);
  } else {
    runInitial();
  }

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true
  });
})();
/* Store Credit ifadelerini Cash Back olarak değiştiren script */

